import RedirectShopifyAdmin from './shopify-admin';
import RedirectToOnboarding from './onboarding';

const Redirect = ({ children }) => {
  return <RedirectShopifyAdmin>{children}</RedirectShopifyAdmin>;
};

export default Redirect;
